import React, { Component } from 'react';
import { MyContext } from '../../../context';
import { Query } from 'react-apollo';
import AlertBar from '../../CustomComponents/AlertBar';
import { Dropdown, Spinner, Stack } from 'office-ui-fabric-react';
import { queryAllAIQuestionsFiltered } from '../AIQuestion/AIQuestionQuery';

export default class AIAssistantQuestionsSelector extends Component {

    static contextType = MyContext

    constructor(props) {
        super(props)
        this.state = {
            selectedQuestions: this.props.selectedKeys != null ? this.props.selectedKeys : [],
            automatedOnDemand: this.props.automated,
            hasMultiselect: this.props.hasMultiselect,
            templateGroupsBool: this.props.queryOnTemplateGroups,
            hasOpenQuestion: this.props.hasOpenQuestion,
            isDetailViewDropdown: this.props.isDetailViewDropdown,
            isFromDetailView: this.props.isFromDetailView,
            hasNotifiedParent: false,
            availableAIAssistants: this.props.availableAIAssistants != null ? this.props.availableAIAssistants : [],
            aIQuestionType: this.props.aIQuestionType != null ? this.props.aIQuestionType : "AIAssistantQuestion",
        }

    }

    render() {
        let aIQuestions;
        let aIQuestionType = this.state.aIQuestionType;
        let filterTemplateQuestions = this.state.templateGroupsBool;
        let automatedOnDemand = this.state.automatedOnDemand;
        let fromDetailView = this.state.isFromDetailView
        let availableAIAssistants;
        return (
            <Query query={queryAllAIQuestionsFiltered} variables={{ aIQuestionType, filterTemplateQuestions, automatedOnDemand, fromDetailView }}>
                {({ loading, error, data, refetch }) => {
                    if (loading) return (<Stack
                        verticalAlign="center"
                        horizontalAlign="ecenter"
                        styles={{ root: { height: '100%', width: '100%' } }}
                    >
                        <Spinner
                            label={this.context.getTranslation("common", "loading")}
                            ariaLive="assertive"
                            labelPosition="top"
                        />
                    </Stack>)
                    if (error) {
                        console.log(error)
                        return (
                            <AlertBar message={this.context.getTranslation("compliance", "error")} alertType="error" />
                        );
                    }
                    if (data.getAllAIQuestionsFiltered == null) {
                        return <AlertBar message={this.context.getTranslation("common", "noData")} alertType={"warning"} />
                    }
                    aIQuestions = data.getAllAIQuestionsFiltered.map(v => {
                        return {
                            "key": v.masterItemId,
                            "text": v.name,
                            "question": v.question
                        }
                    })
                    aIQuestions = aIQuestions.sort((a, b) => {
                        if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
                        if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
                        return 0;
                    });
                    if (this.state.isFromDetailView) {
                        if (!this.props.userRules.visibilityDetails) {
                            availableAIAssistants = data.getAllAIQuestionsFiltered.map(v => {
                                return {
                                    "key": v.masterItemId,
                                    "text": v.name,
                                    "question": v.question
                                }
                            })
                        } else {
                            availableAIAssistants = data.getAllAIQuestionsFiltered.filter(question => this.state.availableAIAssistants.includes(question.masterItemId)).map(v => {
                                return {
                                    "key": v.masterItemId,
                                    "text": v.name,
                                    "question": v.question
                                }
                            })
                        }

                        availableAIAssistants = availableAIAssistants.sort((a, b) => {
                            if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
                            if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
                            return 0;
                        });
                        if (this.state.hasOpenQuestion || !this.props.userRules.visibilityDetails) {
                            availableAIAssistants = [{ "key": "-1", "text": this.context.getTranslation("compliance", "aIAssistantOpenQuestion") }, ...availableAIAssistants]
                        }
                    }
                    if (!this.state.hasNotifiedParent && this.state.isFromDetailView) {
                        this.setState({ hasNotifiedParent: true })
                        this.props.querySuccesful(true)
                    }
                    if (this.state.hasOpenQuestion) {
                        aIQuestions = [{ "key": "-1", "text": this.context.getTranslation("compliance", "aIAssistantOpenQuestion") }, ...aIQuestions]
                    }
                    return (

                        <Dropdown
                            {... (this.state.isFromDetailView
                                ? { placeholder: this.context.getTranslation("compliance", "selectAIQuestionDetailView") }
                                : { placeholder: this.context.getTranslation("compliance", "selectAIQuestion") })
                            }
                            disabled={this.props.disabled}
                            multiSelect={this.state.hasMultiselect}
                            {...(this.state.hasMultiselect
                                ? { selectedKeys: this.state.selectedQuestions }
                                : { selectedKey: this.state.selectedQuestions })}
                            style={this.state.isFromDetailView
                                ? { /*width: "500px",*/ marginRight: "15px", minWidth: "200px" }
                                : {}}
                            {...(this.state.isFromDetailView
                                ? {
                                    options: availableAIAssistants
                                }
                                : { options: aIQuestions })}
                            onChange={(event, item) => {
                                if (item && this.state.hasMultiselect) {
                                    let newSelectedQuestions = item.selected ? [...this.state.selectedQuestions, item.key] : this.state.selectedQuestions.filter(key => key !== item.key)
                                    this.setState({ selectedQuestions: newSelectedQuestions })
                                    this.props.onChangeAIAssistantQuestions(newSelectedQuestions)
                                }
                                else {
                                    this.setState({ selectedQuestions: item.key })
                                    this.props.onChangeAIAssistantQuestions(item.key)
                                }
                                if (this.state.isFromDetailView) {
                                    this.props.question(item.question)
                                }
                            }}
                        />
                    )
                }}
            </Query>

        )
    }
}